import { render, staticRenderFns } from "./UserProfileViewFollowing.vue?vue&type=template&id=77ca8d94&"
import script from "./UserProfileViewFollowing.vue?vue&type=script&lang=js&"
export * from "./UserProfileViewFollowing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports